/**
 * A timeline time as milliseconds, or NaN when it is unreadable. Jira writes its offset as `-0400`, which
 * Safari cannot parse, so it is read as `-04:00`.
 */
export function timelineInstant(at: string | undefined | null): number {
  return Date.parse((at ?? '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2'))
}

/**
 * Items by time, newest first, which is how every timeline in ADX's Claude pages reads. An item without a
 * readable time goes last, and items with the same time keep the order they came in.
 */
export function newestFirst<T>(items: readonly T[], timeOf: (item: T) => string | undefined | null): T[] {
  const instant = (item: T) => {
    const parsed = timelineInstant(timeOf(item))
    return Number.isNaN(parsed) ? -Infinity : parsed
  }
  return [...items].sort((a, b) => instant(b) - instant(a))
}
